import React, { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { Grid } from '@mui/material';
import useRouter from 'utils/useRouter';
import { Page, Header } from 'components';
import ActivityDetailsDataTable from './components/ActivityDetailsDataTable';
import { GetActivity, GetActivityElements, ChangeColumnVisibility } from '../../actions/ActivityViewActions.js';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	},
}));

const ActivityDetails = (props) => {
	const classes = useStyles();
	const { history } = useRouter();
	const { match } = props;
	const { params } = match;
	const { id } = params;
	const dispatch = useDispatch();
	const activity = useSelector(state => state.activityViewReducer.activity);
	const activityElements = useSelector(state => state.activityViewReducer.activityElements);
	const visibleColumns = useSelector(state => state.activityViewReducer.visibleColumns);
	const user = useSelector(state => state.session.user);

	const _getData = useCallback(() => {
		dispatch(GetActivity(user.id, id));
		dispatch(GetActivityElements(id));
	}, []);

	useEffect(() => {
		_getData();
	}, [_getData]);

	const _openTaskDetails = (taskId) => {
		history.push(`/tracker/taskdetails/${taskId}`);
	};

	const _changeColumnVisibility = (changeColumn) => {
		dispatch(ChangeColumnVisibility(changeColumn));
	};

	return (
		<Page className={classes.root} title="Tracker">
			<Header module="Tracker" view={(activity && activity.activityName) || 'Activity Details'} />
			<Grid className={classes.container} container spacing={3}>
				<Grid item lg={12} xs={12}>
					<ActivityDetailsDataTable
						id={`ActivityDataTable_${id}`}
						className={classes.results}
						data={activityElements && activityElements.map(item => {
							let object = { element: item.element };
							item.activityElementTasks.map(element => {
								object = { ...object, [element.activityTaskId.toString()]: element.statusName, [`elementTaskId_${element.activityTaskId}`]: element.elementTaskId };
								return true;
							});
							return object;
						})}
						activityTasks={(activity && activity.tasks) || []}
						openTaskDetails={_openTaskDetails}
						userId={user.id}
						changeColumnVisibility={_changeColumnVisibility}
						visibleColumns={visibleColumns}
					/>
				</Grid>
			</Grid>
			{/* {openAddEditUserDialog && <AddEditUsersDialog
				onClose={_addEditUserClose}
				open={openAddEditUserDialog}
				user={user}
			/>} */}
		</Page>

	);
};

ActivityDetails.propTypes = {
	match: PropTypes.object,
};

export default ActivityDetails;
